import type { AriaAttributes, DOMAttributes } from 'react';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

import * as S from './Tab.styles';
import { switchPaddingSettings } from './Tab.styles';

export type TabSize = 's' | 'm' | 'l';
export type TabVariant = 'underline' | 'segmented';
export interface TabProps
  extends
    AriaAttributes,
    Pick<
      DOMAttributes<HTMLElement>,
      'onClick' | 'onMouseEnter' | 'onMouseLeave'
    > {
  children: React.ReactNode;
  href?: string;
  id?: string;
  isActive?: boolean;
  role?: string;
  size?: TabSize;
  tabIndex?: number;
  variant?: TabVariant;
}

export const Tab = ({
  children,
  href,
  isActive = false,
  onClick,
  size = 'm',
  variant = 'underline',
  ...rest
}: TabProps) => {
  const isLink = !!href;
  const props = isLink ? {} : { onClick };

  const render = () => (
    <S.Wrapper
      forwardedAs={isLink ? 'a' : 'button'}
      isActive={isActive}
      scale='p2'
      size={size}
      variant={variant}
      {...props}
      {...rest}
      {...switchPaddingSettings(size)}
    >
      {children}
    </S.Wrapper>
  );

  return isLink ? (
    <LinkWithLocale href={href} passHref>
      {render()}
    </LinkWithLocale>
  ) : (
    render()
  );
};

Tab.displayName = 'Tab';
